export default "__VITE_ASSET__DGUhiRNX__"